import { Container } from "@components/wrapper"
import { SchoolLearningExperienceImage } from "@interfaces/school"
import Image from "next/image"
import React from "react"
import { BootcampHeading } from "../general/ProgramHeading"

export const BootcampLearnMethod = ({ methods }: { methods: SchoolLearningExperienceImage[] }) => {
  return (
    <div className="bg-[#EFEFEF] sm:py-20 py-10">
      <Container>
        <div className="relative sm:mb-9 mb-6">
          <BootcampHeading
            id="methods"
            title="metode belajar"
            subTitle="Rangkaian Petualangan yang Akan Kamu Lalui"
          />
        </div>

        <div className="sm:flex sm:gap-[3vw] gap-6 grid">
          <div className="sm:w-1/2 w-full sm:flex-1">
            <Image
              src={methods[0].learning_image_url}
              width={590}
              height={987}
              alt="bootcamp learn method"
              className="w-full h-full object-cover rounded-[20px]"
            />
          </div>
          <div className="sm:w-1/2 w-full sm:flex grid flex-col sm:gap-[3vw] gap-6 sm:flex-1">
            {[methods[1], methods[2]].map((method) => (
              <Image
                src={method.learning_image_url}
                width={590}
                height={475}
                alt={method.learning_name}
                key={method.id}
                className="w-full object-cover rounded-[20px]"
              />
            ))}
          </div>
        </div>
      </Container>
    </div>
  )
}
